module.exports = __webpack_public_path__ + "img/syscore_logo_mini.b580d1fb.svg";